module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/t29Bp1/tc-custom/9781459226203.jpg?1704761334922",
      "alt": "This image is the cover for the book Married to a Stranger, Danger & Desire"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Married to a Stranger, Danger & Desire\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Sophia Langley's life is in turmoil. When she learns of her estranged fiancé's death in a shipwreck, the last thing she expects is for his twin brother, Callum Chatterton, to make a shock proposal!"), _c('br'), _c('br'), _vm._v("Her inner romantic objects to a marriage of convenienceand brooding Cal makes it "), _c('i', [_vm._v("very")]), _vm._v(" clear that's all it can be. Yet to save her family Sophia accepts with trepidationand a highly inconvenient trembling of desire for her reluctant husband!"), _c('br'), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Louise Allen\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Louise Allen has been immersing herself in history for as long as she can remember, finding landscapes and places evoke powerful images of the past. Venice, Burgundy & the Greek islands are favourites. Louise lives on the Norfolk coast & spends her spare time gardening, researching family history or travelling. Please visit Louise's website, www.louiseallenregency.com, her blog https://janeaustenslondon or find her on Twitter @LouiseRegency and on Facebook.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0